import axios from 'axios';
// config
import { HOST_API } from '../config';
import { PATH_DASHBOARD } from 'src/routes/paths';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

const resolveDynamicPath = (pathStr, contextObj) => {
  if (!pathStr || !pathStr.startsWith('PATH_DASHBOARD')) return null;

  const keys = pathStr.split('.').slice(1); // remove "PATH_DASHBOARD"
  return keys.reduce((acc, key) => (acc ? acc[key] : null), contextObj);
};

axiosInstance.interceptors.request.use((config) => {
  const pathname = window.location.pathname;

  const user = JSON.parse(localStorage.getItem('user'));

  const forms = user?.forms || [];

  const matchedForm = forms.find((form) => {
    const resolvedPath = resolveDynamicPath(form.formLink, PATH_DASHBOARD);
    return resolvedPath === pathname;
  });

  const formId = matchedForm?.formId;

  // Add to headers ✅
  if (formId) {
    config.headers['form-id'] = formId;
  }

  return config;
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("interceptor error", error);
    // Don't use hooks here - let the calling component handle error display
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
